module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Ticket/ticket-single/ticket-single.component.css
// module id = ./src/app/Ticket/ticket-single/ticket-single.component.css
// module chunks = main